// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-sm":"(min-width: 768px)","mediaBreakpointSm":"(min-width: 768px)","back":"_3-QSv9_u absolute flex items-center p0"};